export const setStorageWithExpiry = (key, value, ttl, metadata={}) => {
	const now = new Date();

	const item = {
		value: value,
		metadata: metadata,
		expiry:  now.getTime() + ttl,
        createdAt: now.getTime()
	};

    localStorage.setItem(key, JSON.stringify(item));
}

export const getStorageWithExpiry = (key) => {
	const itemStr = localStorage.getItem(key);
	
	if (!itemStr) {
		return null;
	}
	const item = JSON.parse(itemStr);
	const now = new Date();
	
	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key);
		return null;
	}
	return item;
}

export const getStorageValueWithExpiry = (key) => {
	const item = getStorageWithExpiry(key);
	if(!item){
		return null;
	}
	return item.value;
};

export const getStorageMetadata = (key) => {
	const item = getStorageWithExpiry(key);
	
	if(!item){
		return null;
	}
	let { metadata } = item;
	metadata.createdAt =  item?.createdAt
	return metadata;
};

export const getLastCalledTimeKey = (id) =>{
	return `call_monitor_lastcalledtime_${id}`;
}

export const getCallMessagesKey = (id) =>{
	return `call_monitor_getcallmessages_${id}`;
}
